<template>
  <div
    class="RoadmapCard"
    :style="
      backgroundColor ? { background: String(backgroundColor) } : undefined
    "
  >
    <div class="RoadmapCard__header">
      <span class="RoadmapCard__index">{{ index }}</span>
      <h2 class="RoadmapCard__title">{{ title }}</h2>
    </div>
    <p class="RoadmapCard__description">{{ description }}</p>
    <img v-if="image" :src="image" :alt="title" class="RoadmapCard__image" loading="lazy" />
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue'

defineProps({
  index: {
    type: Number,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  image: {
    type: String,
    default: '',
  },
  backgroundColor: {
    type: String as PropType<string | undefined>,
    default: undefined,
  },
})
</script>

<style lang="scss" scoped>
.RoadmapCard {
  background: $color-ui-gray-cool-50;
  border: none;
  border-radius: 0.75rem;
  padding: 1rem;
  border-radius: var(--radius-2xl, 16px);
  box-shadow:
    0 1px 3px 0 #0010350a,
    0 1px 2px -1px #0010350a;
  min-height: 12rem;
  height: 100%;
  width: 22.5rem;
  display: flex;
  flex-direction: column;

  .RoadmapCard__header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .RoadmapCard__index {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 2.375rem;
    width: 2.375rem;
    height: 2.375rem;
    border-radius: 0.75rem;
    background: $color-ui-gray-cool-50;
    color: $color-ui-gray-cool-700;
    border: 1px solid $color-ui-gray-cool-700;
    font-weight: 600;
    font-size: 0.875rem;
  }

  .RoadmapCard__title {
    font-weight: 600;
    margin: 0;
  }

  .RoadmapCard__description {
    color: $newcolor-grey-600;
    font-size: 0.95rem;
    margin: 0.25rem 0 0.5rem;
  }

  .RoadmapCard__image {
    width: auto;
    height: 9.375rem;
    border-radius: 0.5rem;
    margin-top: auto;
    object-fit: contain;
    align-self: flex-start;
    display: block;
  }
}

.RoadmapCard--active {
  background: $color-white;
}
</style>
